export default __webpack_public_path__ + "static/media/senti.waterworks.c77d0cf8.svg";